import { render, staticRenderFns } from "./SolutionRootCause.vue?vue&type=template&id=4985c4d0&scoped=true"
import script from "./SolutionRootCause.vue?vue&type=script&lang=js"
export * from "./SolutionRootCause.vue?vue&type=script&lang=js"
import style0 from "./SolutionRootCause.vue?vue&type=style&index=0&id=4985c4d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4985c4d0",
  null
  
)

export default component.exports